import { render, staticRenderFns } from "./CouponsCreate.vue?vue&type=template&id=113f4efd&"
import script from "./CouponsCreate.vue?vue&type=script&lang=js&"
export * from "./CouponsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports